import React from "react";
import { Link } from "@reach/router";
import Constants from "../constants/Constants";

const SubscriptionItem = (props) => {
  const { model, user } = props;
  return (
    <div className="box_thumb">
      <div className="photo">
        <Link to={`${Constants.MA}${model.site_url}`}>
          <img
            src={`https://static.addfriends.com/images/friends/${model.site_url}.jpg`}
            alt={model.site_name}
          />
        </Link>
      </div>
      <div className="content">
        <div className="row">
          <div className="name">
            <div className="sup">Friendname</div>
            <div className="sub">{model.site_name}</div>
          </div>
          {user.snapname && user.snapname !== "none" && (
            <div className="sp_name">
              <div className="sup">Private Account</div>
              <div className="large">
                <i className="icon-snapchat" />
                <a
                  href={`https://www.snapchat.com/add/${user.snapname}`}
                  rel="noreferrer noopener"
                  target="_blank"
                >
                  {user.snapname}
                </a>
              </div>
            </div>
          )}
        </div>
        <div className="row second">
          <Link to={`${Constants.MA}${model.site_url}`} className="button">
            <i className="icon-copy" />
            <span>View my videos</span>
          </Link>

          <Link to={`${Constants.MA}profile`} className="btn">
            Manage your membership
          </Link>
        </div>
      </div>
    </div>
  );
};

export default SubscriptionItem;
